import React from "react";

// Catches errors thrown while a lazy-loaded route chunk fails to load (e.g. a
// stale reference after a new deploy) so the app shows a recoverable message
// instead of hanging on a blank/black screen until the user thinks to refresh.
class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("Route failed to load:", error);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 99999,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
            background: "#0f2027",
            color: "#fff",
            fontFamily: "Montserrat, sans-serif",
            textAlign: "center",
            padding: "1.5rem",
          }}
        >
          <p style={{ fontSize: "1.1rem", margin: 0 }}>
            Something didn't load correctly.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: "0.75rem 1.5rem",
              borderRadius: "10px",
              border: "none",
              background: "#0ea5a1",
              color: "#fff",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Reload page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default RouteErrorBoundary;
